import { GET_DESIGNS } from "../actions/types";

const initialState = {
  list: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_DESIGNS:
      return {
        ...state,
        list: action.payload,
      };
    default:
      return state;
  }
}
